import style from "./SignUp.module.scss"
import SignUpSidebar from "../../component/SignUp/signUpSidebar/SignUpSidebar";
import SignUpContainer from "../../component/SignUp/signUpContainer/SignUpContainer";
import {RouteInfo} from "../../route/RouteHelper";


export default function SignUp() {

    return (
        <>
            <section className={style.signUpLayout}>
                <SignUpSidebar/>
                <SignUpContainer/>

            </section>
            <section>

            </section>
        </>

    )
}

export const signUpItem = [
    {
        icon: 'ic-time',
        title: "معرفی",
        subTitle: "وضعیت فروشنده",
        url: RouteInfo.SignUpIntro.globalUrl,
    },
    {
        icon: 'ic-time',
        title: "تکمیل اطلاعات",
        subTitle: "وضعیت فروشنده",
        url: RouteInfo.SignUpSellerType.globalUrl,

    },
    {
        icon: 'ic-time',
        title: "آدرس",
        subTitle: "وضعیت فروشنده",
        url: RouteInfo.LegalPerson.globalUrl,

    },
    {
        icon: 'ic-time',
        title: "قوانین و مقررات",
        subTitle: "وضعیت فروشنده",

    },
    {
        icon: 'ic-time',
        title: "ورود به پنل",
        subTitle: "وضعیت فروشنده",

    },
]